import { useContext } from 'react';
import { FilesPreviewContext } from '.';
export const useFilesPreview = () => {
    const context = useContext(FilesPreviewContext);
    if (!context) {
        throw new Error('useFilesPreview hook used outside <FilesPreview />');
    }
    return context;
};
